import { useEffect } from 'react';
import throttle from 'lodash/throttle';
const THROTTLE_TIMEOUT = 200;
export function useOnScroll(contentRef, onScrolled, throttleTimeout = THROTTLE_TIMEOUT, preventLeakyScroll = true) {
    useEffect(()=>{
        const contentNode = contentRef.current;
        if (!onScrolled || !contentNode) {
            return;
        }
        const handleScroll = throttle(()=>{
            const { scrollTop , scrollHeight , clientHeight  } = contentNode;
            const distanceToBottom = scrollHeight - scrollTop - clientHeight;
            onScrolled(scrollTop, distanceToBottom);
        }, throttleTimeout, {
            leading: true,
            trailing: true
        });
        // can't use NoLeakyScroll because also need to deal with scroll events
        const handleWheel = (e)=>{
            if (!contentNode || contentNode.scrollHeight <= contentNode.clientHeight) {
                return;
            }
            if (e.deltaY < 0 && contentNode.scrollTop === 0) {
                e.preventDefault();
            }
            if (e.deltaY > 0 && contentNode.scrollTop === contentNode.scrollHeight - contentNode.clientHeight) {
                e.preventDefault();
            }
        };
        handleScroll();
        contentNode.addEventListener('scroll', handleScroll);
        if (preventLeakyScroll) {
            contentNode.addEventListener('wheel', handleWheel);
        }
        return ()=>{
            contentNode.removeEventListener('scroll', handleScroll);
            contentNode.removeEventListener('wheel', handleWheel);
        };
    }, [
        contentRef,
        onScrolled,
        preventLeakyScroll,
        throttleTimeout
    ]);
}
